import React from 'react';
import Image from 'next/image';
import { HomepageTestimonial } from '@/shared/types/homepage';
import classNames from 'classnames';
import './index.less';

interface IProps {
  testimonial: HomepageTestimonial;
}

const TestimonialSection = ({ testimonial }: IProps) => {
  const { author, bgColor, image, isTextLeft, review, title } = testimonial;

  return (
    <div className={classNames('testimonial-section', { reverse: !isTextLeft })}>
      <div className="content-max">
        <div className="text-section" style={{ backgroundColor: bgColor }}>
          <h3 className="title" style={{ color: title.color }}>
            {title.text}
          </h3>

          <p className="description" style={{ color: review.color }}>
            {review.text}
          </p>

          <div className="author">
            <p className="author-name" style={{ color: review.color }}>
              - {author.name}, {author.brand}
            </p>
          </div>
        </div>

        <div className="secondary-section image" style={{ backgroundColor: bgColor }}>
          <Image
            sizes="(min-width:1024px) 420px,(min-width: 768px) 280px,(min-width:640px) 240px,(min-width:300px) calc(100vw-32px), calc(100vw-32px)"
            src={image}
            width={420}
            height={420}
            alt={title.text}
            loading="lazy"
          />
        </div>
      </div>
    </div>
  );
};

export default TestimonialSection;
